<div class="flex flex-col gap-2">
  @for (group of groups(); track group.name; let i = $index) {
    <cmi-property-group-item
      [groupName]="group.name"
      [providerType]="group.type"
      [isDraggable]="isDraggable()"
      [isDeleting]="deletingGroupName() === group.name"
      [isFirst]="i === 0"
      [isLast]="i === groups().length - 1"
      [isDragging]="draggingName() === group.name"
      [isDragOver]="dragOverName() === group.name"
      [dragOverPosition]="dragOverPosition()"
      (moveUp)="moveUp(group.name)"
      (moveDown)="moveDown(group.name)"
      (edit)="edit.emit(group.name)"
      (confirmDelete)="confirmDelete.emit(group.name)"
      (cancelDelete)="cancelDelete.emit()"
      (delete)="removed.emit(group.name)"
      (dragStarted)="onDragStart($event, group.name)"
      (dragOvered)="onDragOver($event, group.name)"
      (dropped)="onDrop($event, group.name)"
      (dragEnded)="onDragEnd()" />
  }
</div>
